module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-41-min.4b26e384.jpg";